module.exports = __webpack_public_path__ + "img/8.5fd07c9b.png";